import { GenericMetaNode } from "oc-scene-editor/nodes/metadata/GenericMetaNode";
import { PAny } from "oc-scene-editor/nodes/properties/PAny";
import { PForeignKey } from "oc-scene-editor/nodes/properties/PForeignKey";
import { PImage } from "oc-scene-editor/nodes/properties/PImage";
import { PString } from "oc-scene-editor/nodes/properties/PString";
import { MAuswahlwert } from "../../../../../metamodell";
import { AuswahlBildvorschau } from "../../AuswahlBildvorschau";

export type VisualPropsOfAuswahlwert = {
  Auswahlbild: string;
  Thumbnail: string;
  Name: string;
  Bezeichnung: string;
};
export class Auswahlwert extends GenericMetaNode {
  meta: MAuswahlwert;
  metaTable: (typeof APP.metamodel.tables)[0];
  Auswahlbild: string;
  Thumbnail: string;
  Name: string;
  Bezeichnung: string;

  getName(): string {
    return `${this.meta?.Auswahl?.Key ?? ""} - ${super.getName()}`;
  }

  createProperties(): any {
    const auswahlCol = this.metaTable?.columns?.find((c) => c.name === "Auswahl");
    return [
      new PAny({
        name: "id",
        type: "Id",
        node: this,
        showInEditor: (p) => false,
      }),
      new PString({
        name: "Key",
        primaryKey: true,
        comment: "Interner eindeutiger Primärschlüssel",
        node: this,
      }),
      new PForeignKey({
        name: "Auswahl",
        foreignKey: auswahlCol?.foreignKey,
        selectOptions: auswahlCol?.selectOptions,
        editable: false,
        node: this,
      }),
      new PString({
        name: "Name",
        node: this,
      }),
      new PString({
        name: "Bezeichnung",
        node: this,
      }),
      new PImage({
        name: "Auswahlbild",
        contentPath: "Auswahlwert/",
        comment: "Bild in großen Auswahlen",
        defaultInJson: false,
        showInEditor: (p) => true,
        node: this,
      }),
      new PImage({
        name: "Thumbnail",
        contentPath: "Auswahlwert/",
        comment: "Bild in kleinen Auswahlen",
        defaultInJson: false,
        showInEditor: (p) => true,
        node: this,
      }),
      {
        render: () => AuswahlBildvorschau(this.meta, this.getVisualProps()),
      },
    ];
  }

  getVisualProps(): VisualPropsOfAuswahlwert {
    return {
      Auswahlbild: this.Auswahlbild,
      Thumbnail: this.Thumbnail,
      Name: this.Name,
      Bezeichnung: this.Bezeichnung,
    };
  }

  toMetadataRow() {
    const old = Object.fromEntries(
      (this.metaTable as typeof APP.metamodel.Auswahl).columns
        .filter(({ type }) => type != "Backref")
        .map(({ name }) => [name, this.meta[name]])
    );
    const current = super.toMetadataRow();
    ["Auswahlbild", "Thumbnail"].forEach(
      (key) => (current[key] = current[key]?.substringAfter("Auswahlwert/"))
    );
    return { ...old, ...current };
  }
}
